import {
  BusinessLeasingType,
  FinancialLeasingType,
} from '../../../../types/index';

const getBusinessRest = (
  mileage: number,
  businessLeasing: BusinessLeasingType,
) => {
  switch (mileage) {
    case 1500:
      return businessLeasing.restvarde1;
    case 2000:
      return businessLeasing.restvarde2;
    case 3000:
      return businessLeasing.restvarde3;
    default:
      return businessLeasing.restvarde4;
  }
};

const getBusinessService = (
  mileage: number,
  businessLeasing: BusinessLeasingType,
) => {
  switch (mileage) {
    case 1500:
      return businessLeasing.serviceniva1;
    case 2000:
      return businessLeasing.serviceniva2;
    case 3000:
      return businessLeasing.serviceniva3;
    default:
      return businessLeasing.serviceniva4;
  }
};

const getBusinessForsakring = (
  milage: number,
  businessLeasing: BusinessLeasingType,
) => {
  switch (milage) {
    case 1500:
      return businessLeasing.forsakring_4500_ingen_moms;
    case 2000:
      return businessLeasing.forsakring_6000_ingen_moms;
    case 3000:
      return businessLeasing.forsakring_9000_ingen_moms;
    default:
      return businessLeasing.forsakring_12000_ingen_moms;
  }
};

const getFinancialRest = (
  mileage: number,
  financialLeasing: FinancialLeasingType,
) => {
  switch (mileage) {
    case 1500:
      return financialLeasing.restvarde4500_ex_moms;
    case 2000:
      return financialLeasing.restvarde6000_ex_moms;
    case 3000:
      return financialLeasing.restvarde6000_ex_moms;
    default:
      return financialLeasing.restvarde9000_ex_moms;
  }
};

const getFinancialService = (
  mileage: number,
  financialLeasing: FinancialLeasingType,
) => {
  switch (mileage) {
    case 1500:
      return financialLeasing.service4500_ex_moms;
    case 2000:
      return financialLeasing.service6000_exmoms;
    case 3000:
      return financialLeasing.service9000_ex_moms;
    default:
      return financialLeasing.service12000_ex_moms;
  }
};

const getFinancialForsakring = (
  mileage: number,
  financialLeasing: FinancialLeasingType,
) => {
  switch (mileage) {
    case 1500:
      return financialLeasing.forsakring4500;
    case 2000:
      return financialLeasing.forsakring6000;
    case 3000:
      return financialLeasing.forsakring9000;
    default:
      return financialLeasing.forsakring12000;
  }
};

export {
  getBusinessForsakring,
  getBusinessRest,
  getBusinessService,
  getFinancialForsakring,
  getFinancialRest,
  getFinancialService,
};
